export default "__VITE_ASSET__BnTDeHdp__"